const yesNoOptions = (t) => [
  { id: "true", label: t("form.yes") },
  { id: "false", label: t("form.no") },
];

export default yesNoOptions;
